import { SyncOutlined } from '@ant-design/icons'
import { Button, Popconfirm } from 'antd'
import { useState } from 'react'

import { HivAnamnesisFormSection } from 'src/api/requests'
import { useLocales } from 'src/locales'

import { useHivAnamnesisForm } from '../context/HivAnamnesisFormContext'

type Props = {
  sections: HivAnamnesisFormSection[]
}

/**
 * "Preia din sistem": fills a section of a saved fișa with the data the system has now (e.g. results
 * added after the draft was saved). What the doctor entered stays where the system has nothing.
 */
export const SystemRefreshButton = ({ sections }: Props) => {
  const { t } = useLocales()
  const { isEditing, refreshFromSystem } = useHivAnamnesisForm()
  const [isLoading, setIsLoading] = useState(false)

  if (!isEditing || !refreshFromSystem) return null

  const onConfirm = async () => {
    setIsLoading(true)
    try {
      await refreshFromSystem(sections)
    } finally {
      setIsLoading(false)
    }
  }

  return (
    <Popconfirm
      title={t('hiv_anamnesis.refresh.confirm')}
      description={t('hiv_anamnesis.refresh.description')}
      onConfirm={() => void onConfirm()}
      okButtonProps={{ loading: isLoading }}
    >
      <Button icon={<SyncOutlined />} loading={isLoading}>
        {t('hiv_anamnesis.refresh.button')}
      </Button>
    </Popconfirm>
  )
}
